import { isMockMode, post, simulateDelay } from "../api";

export const updateOrgSysadmin = (data) => {
	if (isMockMode()) {
		const testData = {
			success: true,
		};
		return simulateDelay(50, () => testData);
	}

	return post(`sysadmin/updateorg`, data);
};
